import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { pagesSlice } from './features/pages/pagesSlice';
import appContextSlice from './features/context/slice';
import zoomSlice from './features/zoom/zoomSlice';
import { fileSlice } from './features/files/filesSlice';
import { newFilesSlice } from './features/newFiles/newFilesSlice';
import { downloadSlice, uplooadsSlice } from './features/progress/progressSlicer';

export const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
    reducer: {
        pages: pagesSlice.reducer,
        files: fileSlice.reducer,
        context: appContextSlice,
        zoom: zoomSlice,
        newFiles: newFilesSlice.reducer,
        uploads: uplooadsSlice.reducer,
        downloads: downloadSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(listenerMiddleware.middleware)
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
